<div *callToAction></div>

<div class="settings-title-container">
  <h1>{{ "settingTenant.configuration" | translate }}</h1>
</div>

<div *ngIf="existConfig" class="content">
  <form [formGroup]="configForm" fxLayout="column" fxLayoutGap="32px">
    @if (isBrianApp()) {
      <div>
        <div class="section-title-with-info">
          <h3>{{ "logoManagement.sectionTitle" | translate }}</h3>
          <evc-svg-icon
            [matTooltip]="'logoManagement.information' | translate"
            matTooltipPosition="above"
            matTooltipTouchGestures="on"
            [matTooltipShowDelay]="0"
            size="md"
            icon="circle-info"
          >
          </evc-svg-icon>
        </div>
        <div class="logo-container">
          @if (logoUrl) {
            <img [src]="logoUrl" alt="logo" />
            <evc-nav-button class="import-logo" [size]="'sm'" type="secondary" [leftIcon]="'pen-to-square'" (click)="openImportLogoManagement()">
              {{ "common.edit" | translate }}
            </evc-nav-button>
          } @else {
            <evc-nav-button class="import-logo" [size]="'sm'" type="secondary" [leftIcon]="'download'" (click)="openImportLogoManagement()">
              {{ "logoManagement.importLogo" | translate }}
            </evc-nav-button>
          }
        </div>
      </div>
    }

    @if (isAppOnline()) {
      <div formGroupName="EnableAdvancedFeatures">
        <h3>{{ enableAdvancedFeaturesHeader | translate }}</h3>
        <div fxLayout="column" fxLayoutGap="24px" class="form-group-content">
          <div class="switch-container">
            <label class="switch">
              <input type="checkbox" [formControlName]="enableAdvancedFeature.controlName" (change)="submit()" />
              <span class="slider round"></span>
            </label>
            <span>{{ enableAdvancedFeature.displayKey | translate }}</span>
          </div>
        </div>
      </div>
    }

    @if (isAppOnline() && isGeConnectorFeatureFlagEnabled()) {
      <app-settings-connector />
    }

    <div formGroupName="SwitchApplicationBehavior">
      <h3>{{ switchApplicationBehaviorHeader | translate }}</h3>
      <div class="form-group-content">
        <div *ngFor="let obj of switchApplicationBehaviorGroup" fxLayout="column">
          <label>{{ obj.displayKey | translate: { markLabel: this.markLabel } }}</label>
          <mat-form-field>
            <mat-select [formControlName]="obj.controlName" hideSingleSelectionIndicator (selectionChange)="submit()">
              <mat-option *ngFor="let item of obj.selectItems" [value]="item.value">
                {{ item.displayLabel | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>

    @if (!isAssetModuleEnabled()) {
      <div formGroupName="AdditionalAttribute">
        <h3>{{ additionalAttributeHeader | translate }}</h3>
        <div fxLayout="column" fxLayoutGap="24px" class="form-group-content">
          <div *ngFor="let obj of additionalAttributeGroup" fxLayout="column">
            <label>{{ obj.firstPartDisplayKey | translate }} - {{ obj.secondPartDisplayKey | translate }}</label>
            <mat-radio-group [formControlName]="obj.controlName" (change)="submit()">
              <mat-radio-button *ngFor="let item of obj.selectItems" [value]="item.value">
                {{ item.displayLabel | translate }}
              </mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
      </div>
    }

    <div formGroupName="DefineTerminology">
      <h3>{{ defineTerminologyHeader | translate }}</h3>
      <div class="form-group-content">
        <div *ngFor="let obj of filteredDefineTerminology()" fxLayout="column">
          <label>{{ obj.displayKey | translate }}</label>
          <mat-form-field>
            <input matInput [formControlName]="obj.controlName" [maxLength]="defineTerminologyMaxLength" (blur)="submit()" />
            <mat-hint class="hint-error" *ngIf="configForm.controls.DefineTerminology.controls[obj.controlName].invalid">
              {{ requiredError | translate }}
            </mat-hint>
            <mat-hint align="end">
              {{ configForm.controls.DefineTerminology.controls[obj.controlName].value.length }}/ {{ defineTerminologyMaxLength }}
            </mat-hint>
          </mat-form-field>
        </div>
      </div>
    </div>
  </form>
</div>

<div *ngIf="!existConfig" class="content" fxLayoutAlign="center">
  {{ "settingTenant.notFound" | translate }}
</div>
